module.exports = __webpack_public_path__ + "img/notice01.73819486.png";